var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.48852 7.51793V11.0933C9.48852 11.0933 12.8781 11.0886 14.2583 11.0886C13.5109 13.4065 12.3488 14.6686 9.48852 14.6686C6.59395 14.6686 4.33478 12.2675 4.33478 9.30561C4.33478 6.34369 6.59395 3.94257 9.48852 3.94257C11.0189 3.94257 12.0073 4.493 12.9139 5.26018C13.6396 4.51758 13.579 4.41175 15.4254 2.62756C13.858 1.16774 11.7749 0.277832 9.48852 0.277832C4.61596 0.277832 0.666016 4.31968 0.666016 9.30561C0.666016 14.2914 4.61596 18.3334 9.48852 18.3334C16.7716 18.3334 18.5518 11.8441 17.9616 7.51793C16.2375 7.51793 9.48852 7.51793 9.48852 7.51793Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/googleLogo.d4f686bb6b180de710c51a5927dec8bf.svg";
export { ForwardRef as ReactComponent };